// src/config/themes.ts

// Kita ekspor tipe 'Theme' dari sini agar menjadi sumber utama
export type Theme = 'emerald' | 'blue' | 'purple' | 'amber';

// Kita ekspor array 'themes' agar bisa di-import di mana saja
export const themes: { id: Theme; name: string; primary: string; secondary: string }[] = [
  { id: 'emerald', name: 'Emerald', primary: 'bg-emerald-500', secondary: 'bg-emerald-100' },
  { id: 'blue', name: 'Blue', primary: 'bg-blue-500', secondary: 'bg-blue-100' },
  { id: 'purple', name: 'Purple', primary: 'bg-purple-500', secondary: 'bg-purple-100' },
  { id: 'amber', name: 'Amber', primary: 'bg-amber-500', secondary: 'bg-amber-100' }
];